import { useQuery } from "react-query";

import { searchService } from "services";

type UseBoardingSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useBoardingSearchQuery = ({
	pattern,
	page,
	options,
}: UseBoardingSearchQueryProps) =>
	useQuery(
		["boardingSearch", pattern, page],
		() =>
			searchService.getBoardings({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useBoardingSearchQuery;
